<template>
  <div>
    <div class="home-page">
      <div class="bg"></div>
      <div class="content">
        <div class="core">
          <div class="btn">
            <img src="./../../assets/home/microscopeTrue.png" alt="" />
            显微镜操作判读考核
          </div>
          <div class="text">
            本环节中您将模拟显微镜操作判读过程:请按照提示完成显微镜调试，之后您将随机获得两张玻片，并分别进行判读。每人只有一次考试机会。总分<span>100</span>分，作答时间<span>20</span>分钟。
          </div>
          <div class="text">
            显微镜操作判读考核的答案即时查看。欢迎大家通过爱波克杯皮肤病大赛小程序进入本页面查看答案。
          </div>
          <div @click="handleGoMicroscopeStart" class="partake">参与考试</div>
        </div>
        <div @click="handleGoMicroscopeGrade" class="rule">评分规则</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home2026",
  data() {
    return {
      isShow: true,
    };
  },
  created() {},
  methods: {
    handleGoMicroscopeStart() {
      this.$router.replace("/microscope/start");
    },
    handleGoMicroscopeGrade() {
      this.$router.replace("/microscope/grade");
    },
  },
};
</script>

<style lang="less" scoped>
.home-page {
  width: 100%;
  min-height: 100vh;
  background-image: url("./../../assets/home/cbbj.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .bg {
    height: 90px;
  }
  .content {
    width: 653px;
    height: 1224px;
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
    border-radius: 60px;
    margin: 0 auto;
    padding-top: 1px;
    .core {
      width: 496px;
      margin: 48px 78px;
      height: 856px;
      background: rgba(255, 255, 255, 0.5);
      box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
      border-radius: 60px;
      .btn {
        width: 100%;
        height: 100px;
        border-radius: 50px;
        margin: 0 auto;
        font-size: 36px;
        font-family: HarmonyOS Sans SC;
        font-weight: 500;
        line-height: 101px;
        text-align: center;
        border: 1px solid #ffffff;
        background: #e5e5e5;
        color: #333333;
        box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
        img {
          display: inline;
          width: 47px;
          vertical-align: middle;
        }
      }
      .text {
        margin-top: 80px;
        padding: 0 30px;
        font-size: 25px;
        font-family: HarmonyOS Sans SC;
        font-weight: 500;
        color: #4c4c4c;
        line-height: 50px;
        span {
          color: #ab3b91;
        }
      }
      .partake {
        width: 339px;
        height: 69px;
        background: linear-gradient(
          132.74deg,
          rgba(0, 187, 177, 1) 0%,
          rgba(0, 86, 140, 1) 74.31%,
          rgba(171, 59, 127, 1) 100%
        );
        border: 1px solid #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
        border-radius: 34px;
        margin: 0 auto;
        text-align: center;
        line-height: 69px;
        font-size: 35px;
        font-family: HarmonyOS Sans SC;
        font-weight: 500;
        color: #ffffff;
      }
    }
    .rule {
      width: 496px;
      margin: 0 auto;
      height: 66px;
      background: linear-gradient(
        132.74deg,
        rgba(0, 187, 177, 1) 0%,
        rgba(0, 86, 140, 1) 74.31%,
        rgba(171, 59, 127, 1) 100%
      );
      border: 1px solid #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
      opacity: 0.85;
      border-radius: 33px;
      font-size: 35px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #ffffff;
      margin-top: 48px;
      text-align: center;
      line-height: 66px;
    }
  }
}
</style>
